@if (value && value.length > 0) {
  <div class="column-select-container">
    @for (column of value; track column; let columnIndex = $index) {
      <div class="column">
        <ion-select
          #columnSelect
          interface="popover"
          [attr.data-index]="columnIndex"
          (ionChange)="columnChanged($event)"
          [(ngModel)]="selectedValues[columnIndex]"
        >
          @if (allowEmpty) {
            <ion-select-option value="">&mdash;</ion-select-option>
          }
          @for (c of columns; track c) {
            <ion-select-option [value]="c.id">{{ c.name }}</ion-select-option>
          }
        </ion-select>
      </div>
    }
  </div>
} @else {
  <div class="no-columns-message">
    <ion-text color="medium">Žádné sloupce nejsou k dispozici</ion-text>
  </div>
}
